import React from 'react';
import { useTranslation } from 'react-i18next';
// useHistory нам здесь больше не нужен, так как мы убрали кнопку "Назад",
// но если планируешь вернуть, можешь оставить импорт.

const ComingSoon = ({ sectionName, color }) => {
    const { t } = useTranslation();

    return (
        <div className="coming-soon">
            <div className="coming-soon__content">

                {/* Вставляем наш Атом вместо старой SVG иконки */}
                <div className="coming-soon__atom-wrapper">
                    <div className="atom-spinner">
                        <div className="atom-spinner__orbit orbit-1"></div>
                        <div className="atom-spinner__orbit orbit-2"></div>
                        <div className="atom-spinner__orbit orbit-3"></div>
                    </div>
                </div>

                {/* Применяем переданный цвет через style */}
                <h1
                    className="coming-soon__title_section_name"
                    style={{ color: color }}
                >
                    {sectionName}
                </h1>

                <h1 className="coming-soon__title">{t('translate.coming_soon_title')}</h1>
                <p className="coming-soon__desc">{t('translate.coming_soon_desc')}</p>

            </div>
        </div>
    );
};

export default ComingSoon;